import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// import dotenv from "dotenv";
import store, { persistor } from "./redux/store";
import { SplashScreenProvider } from "./app/context/LayoutContext";
import { EthizoI18nProvider } from "./app/context/i18n/Ethizoi18n";
import * as _redux from "./redux";
import "./index.css";


const setSentryUserData = () => {
  let unsub = store.subscribe(()=>{
    let  storeData = store.getState();
    // console.log("storeData" , storeData);

    let userData = {};
    if(storeData?.providerNote?.selectedPatient?.Patient){
      userData.practice_name = storeData?.providerNote?.selectedPatient?.Patient?.practice_name
    }

    if(storeData?.auth?.user){
      // userData.id = storeData?.auth?.user?.id, 
      userData.name = storeData?.auth?.user?.fname + ' ' + storeData?.auth?.user?.lname,
      userData.email = storeData?.auth?.user?.email,
      userData.practice_id = storeData?.auth?.practice_id,
      userData.username = storeData?.auth?.user?.username,
      console.log('userData: ', userData);

      Sentry.setUser(userData);
      unsub();
    }
  });
}

//Add Sentry
if(process.env.NODE_ENV === 'production') {

  Sentry.init({
    dsn: "https://79f7b927900047b6a5536c8f8137eef0@o1288547.ingest.sentry.io/4504497701257216",
    integrations: [new BrowserTracing()],
  
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  
    integrations: [new Sentry.Replay()],
  });

  setSentryUserData();
  console.log('Sentry userData Production');
}

// Add Sentry for Development
if(process.env.NODE_ENV === 'development' | process.env.NODE_ENV === 'test'){
  
  Sentry.init({
    dsn: "https://0414c97c26f940cdb0445d117185852d@o1288547.ingest.sentry.io/4504605968039936",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [new Sentry.Replay()],
  });

  setSentryUserData();
  console.log('Sentry userData Preprod/Dev');
}

// dotenv.config();

const { PUBLIC_URL } = process.env;

_redux.setupAxios(axios, store);


const container = document.getElementById("root");

// Create a root.
const root = ReactDOM.createRoot(container);


// Initial render
root.render(
  <EthizoI18nProvider>
    <SplashScreenProvider>
      <App store={store} persistor={persistor} basename={PUBLIC_URL} />
    </SplashScreenProvider>
  </EthizoI18nProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
